import { useState, useEffect } from 'react';
import { useNavigate, useCanGoBack, useRouter } from '@tanstack/react-router';
import styles from './BackTo.module.css';
import ChevronLeftIcon from '../icons/ChevronLeftIcon';

export const BACKTO_HEIGHT = "48px";

type NavigateType = string | (() => void);

interface BackToProps {
    label: string;
    route?: NavigateType;
    beforeNavigate?: VoidFunction;
    reload?: boolean;
}

const BackTo = (props: BackToProps) => {
    const router = useRouter();
    const canGoBack = useCanGoBack();
    const navigate = useNavigate();
    const [noBackRoute, setNoBackRoute] = useState(false);

    useEffect(() => {
        if (!props.route && !canGoBack) {
            setNoBackRoute(true);
        }
    }, []);

    const goBack = async () => {
        if (props.beforeNavigate) {
            props.beforeNavigate();
        }
        if (typeof props.route === 'string') {
            if (props.reload) {
                // force a page refresh. useful to force media device recording status icon to refresh.
                window.location.href = `${window.location.origin}${props.route}`;
            }
            await navigate({ to: props.route, viewTransition: true });
        } else if (typeof props.route === 'function') {
            props.route();
        } else if (canGoBack) {
            router.history.back();
        }
    }
    const backtoStyles = {
        height: BACKTO_HEIGHT
    }

    if (noBackRoute) {
        return null;
    }

    return (
        <div className={styles.container} style={backtoStyles}>
            <button onClick={ goBack } className={styles.backButton}>
                <ChevronLeftIcon size={{width: 24, height: 24}} className={styles.icon} />
                <span>{props.label}</span>
            </button>
        </div>
    )
};

export default BackTo;